import { SAGA_ACTIONS } from "src/_config";
import { useApiCall } from "../common/appApiCallHook";

export function useUsersManagementApi() {
  const callApi = useApiCall();

  const createUser = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USERS_MANAGEMENT.CREATE_USER, data, onSuccess, onError);
  };

  const uploadProfilePhoto = (userId: number | string, data: any, onSuccess: Function, onError: Function) => {
    const payload = {
      userId,
      ...data,
    };
    callApi(SAGA_ACTIONS.USERS_MANAGEMENT.UPLOAD_PROFILE_PHOTO, payload, onSuccess, onError);
  };

  const getUsers = (params: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USERS_MANAGEMENT.GET_USERS, params, onSuccess, onError);
  };

  const updateUser = (userId: number | string, data: any, onSuccess: Function, onError: Function) => {
    const payload = {
      userId,
      ...data,
    };
    callApi(SAGA_ACTIONS.USERS_MANAGEMENT.UPDATE_USER, payload, onSuccess, onError);
  };

  const getUser = (userId: number | string, onSuccess: Function, onError: Function) => {
    const payload = { userId };
    callApi(SAGA_ACTIONS.USERS_MANAGEMENT.GET_USER, payload, onSuccess, onError);
  };

  const deleteUser = (userId: number | string, onSuccess: Function, onError: Function) => {
    const payload = { userId };
    callApi(SAGA_ACTIONS.USERS_MANAGEMENT.DELETE_USER, payload, onSuccess, onError);
  };

  const resendWelcomeEmail = (userId: number | string, onSuccess: Function, onError: Function) => {
    const payload = { userId };
    callApi(SAGA_ACTIONS.USERS_MANAGEMENT.RESEND_WELCOME_EMAIL, payload, onSuccess, onError);
  };

  const updateRolePermissions = (userId: number | string, data: any, onSuccess: Function, onError: Function) => {
    const payload = { userId, ...data };
    callApi(SAGA_ACTIONS.USERS_MANAGEMENT.UPDATE_ROLE_PERMISSIONS, payload, onSuccess, onError);
  };

  const getUserPermissions = (userId: number | string, onSuccess: Function, onError: Function) => {
    const payload = { userId };
    callApi(SAGA_ACTIONS.USERS_MANAGEMENT.GET_USER_PERMISSIONS, payload, onSuccess, onError);
  };

  const inviteUser = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USERS_MANAGEMENT.INVITE_USER, data, onSuccess, onError);
  };

  return {
    callCreateUser: createUser,
    callUploadProfilePhoto: uploadProfilePhoto,
    callGetUsers: getUsers,
    callUpdateUser: updateUser,
    callGetUser: getUser,
    callDeleteUser: deleteUser,
    callResendWelcomeEmail: resendWelcomeEmail,
    callUpdateRolePermissions: updateRolePermissions,
    callGetUserPermissions: getUserPermissions,
    callInviteUser: inviteUser,
  };
}
